export const defaultOptions = {
  max: 250,
};
interface defaultLabelerParams {
  count: number;
}

interface countDownParams {
  max: number;
  maxLength: number;
}

export const defaultLabeler = ({ count }: defaultLabelerParams): number =>
  count;

export const countUp = (prevValue: string, value: string): number => {
  return value ? value.length : 0;
};

export const countDown = (
  prevValue: string,
  value: string,
  { max, maxLength }: countDownParams
): number => {
  const computedMax =
    typeof maxLength === 'number' ? Math.min(max, maxLength) : max;
  return value ? computedMax - value.length : computedMax;
};

export const defaultCounters = {
  down: countDown,
  up: countUp,
};
